import React, { Component } from 'react';
import {
  Text,
  View,
  TextInput,
  Dimensions,
  TouchableHighlight,
  Platform,
  ScrollView,
  ActivityIndicator,
  Image
} from 'react-native';
import {StyleContext} from '../styleC';
import strings from '../strings';
import info from '../info';
import countryList from '../countryList';
import moneyList from '../moneyList';

import Modal from './modal';
import MavTextInput from './mavTextInput';
import MavViewMore from './mavViewMore';

import MavButton from './mavButton';
import MavMiniButton from './mavMiniButton';


export default class sncfInfo extends Component {
constructor(props) { 
    super(props);


    
    var num=(this.props.numero!=undefined)?this.props.numero:"";
    num=num.toUpperCase(); 

    num=num.replace("TGV INOUI","")
    num=num.replace("TGV","")
    num=num.replace("TER","")
    num=num.replace("INTERCITES","")
    num=num.replace("INTERCITE","")
    num=num.replace("NUMERO","")
    num=num.replace("NUM","")
    num=num.replace("N°","")
    num=num.replace(/ /g,'')





    this.state = {
      changeNumber:false,
      numTrain:num, 
      trainName:undefined,
      viewDetailTrajet:false,
      hideIconi:(this.props.racePlaceStartName!=undefined)?true:false,
      

    }












      


  }

  findPlace(position){
      fetch("https://api.sncf.com/v1/coverage/sncf/places/"+position.longitude+"%3B"+position.latitude+"/places_nearby?", {method: "GET",headers: {'Authorization': '670396b7-c369-4eae-bb7e-eb3f17426463', 'Content-Type': 'application/x-www-form-urlencoded'}, }).then(response => response.json()).then(responseJson => {
          if(responseJson!=undefined && responseJson.places_nearby!=undefined){
              this.setState({placesNearby:responseJson.places_nearby, placesNearbyI:0},() =>{this.findStationInfo(responseJson.places_nearby[0])})

          }

      })
  }


  findStationInfo(placeID){
      var date=new Date(this.props.raceDate-15*60*1000)
      date=date.getFullYear()+""+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+""+((date.getDate()<10)?"0":"")+date.getDate()+"T"+((date.getHours()<10)?"0":"")+date.getHours()+""+((date.getMinutes()<10)?"0":"")+date.getMinutes()+"00"

      var found=false;
      console.log(date)
      fetch("https://api.sncf.com/v1/coverage/sncf/stop_areas/"+placeID.id+"/arrivals?from_datetime="+date+"&", {method: "GET",headers: {'Authorization': '670396b7-c369-4eae-bb7e-eb3f17426463', 'Content-Type': 'application/x-www-form-urlencoded'}, }).then(response => response.json()).then(responseStation => {

                        if(responseStation!=undefined && responseStation.arrivals!=undefined){

                            var i;
                            for(i=0; i<responseStation.arrivals.length;i++){
                              console.log(responseStation.arrivals[i].display_informations.trip_short_name)
                              if(responseStation.arrivals[i].display_informations!=undefined && (responseStation.arrivals[i].display_informations.trip_short_name==this.state.numTrain || responseStation.arrivals[i].display_informations.headsign==this.state.numTrain)){
                                 
                                
                                var hourTrain=this.convertDate(responseStation.arrivals[i].stop_date_time.base_arrival_date_time)
                                var realHourTrain=this.convertDate(responseStation.arrivals[i].stop_date_time.arrival_date_time)

                                var realHourTrainDisplay=undefined;
                                var delay=0;

                                if((realHourTrain-hourTrain)> 5*60*1000){

                                  delay=(realHourTrain-hourTrain)/60000; 
                                  if(delay>60) delay=parseInt(delay/60)+"h"+((delay%60<10)?"0":"")+delay%60;
                                  else delay=delay+" "+strings.minutes.toLowerCase();

                                  realHourTrainDisplay=responseStation.arrivals[i].stop_date_time.arrival_date_time[9]+responseStation.arrivals[i].stop_date_time.arrival_date_time[10]+":"+responseStation.arrivals[i].stop_date_time.arrival_date_time[11]+responseStation.arrivals[i].stop_date_time.arrival_date_time[12]
                                }

                               
                                var hourTrainDisplay=responseStation.arrivals[i].stop_date_time.base_arrival_date_time[9]+responseStation.arrivals[i].stop_date_time.base_arrival_date_time[10]+":"+responseStation.arrivals[i].stop_date_time.base_arrival_date_time[11]+responseStation.arrivals[i].stop_date_time.base_arrival_date_time[12]
                                
                                this.setState({trainName:responseStation.arrivals[i].display_informations.commercial_mode,stationName:placeID.name, journey:responseStation.arrivals[i].links[1].id, hourTrain:hourTrainDisplay,realHourTrain:realHourTrainDisplay, delay:delay })

                                found=true; 

                              }



                            }

                            

                        }

                        if(found==false){
                          if(this.state.placesNearbyI<this.state.placesNearby.length-1) this.setState({placesNearbyI:this.state.placesNearbyI+1},() =>{this.findStationInfo(this.state.placesNearby[this.state.placesNearbyI])})
                          else this.setState({placesNearbyI:0},() =>{this.findRemoveTrain(this.state.placesNearby[0])})
                        }
                        

                      })

  }

  findRemoveTrain(placeID){
    console.log("findRemoveTrain")

    var date=new Date(this.props.raceDate-15*60*1000)
    date=date.getFullYear()+""+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+""+((date.getDate()<10)?"0":"")+date.getDate()+"T"+((date.getHours()<10)?"0":"")+date.getHours()+""+((date.getMinutes()<10)?"0":"")+date.getMinutes()+"00"

    var found=false;
    fetch("https://api.sncf.com/v1/coverage/sncf/stop_areas/"+placeID.id+"/traffic_reports?from_datetime="+date+"&", {method: "GET",headers: {'Authorization': '670396b7-c369-4eae-bb7e-eb3f17426463', 'Content-Type': 'application/x-www-form-urlencoded'}, }).then(response => response.json()).then(responseDeleted => {


                      if(responseDeleted!=undefined && responseDeleted.disruptions!=undefined){
                          var i; 
                          for(i=0; i<responseDeleted.disruptions.length;i++){
                              if(responseDeleted.disruptions[i].impacted_objects!=undefined && responseDeleted.disruptions[i].impacted_objects[0].pt_object!=undefined && responseDeleted.disruptions[i].impacted_objects[0].pt_object.trip!=undefined && responseDeleted.disruptions[i].impacted_objects[0].pt_object.trip.name==this.state.numTrain) {
                                if(responseDeleted.disruptions[i].severity.effect=="NO_SERVICE"){
                                  
                                    this.setState({noService:true })
                                    found=true;
                                 }

                              }

                          }
                        }

                      if(found==false){
                        if(this.state.placesNearbyI<this.state.placesNearby.length-1) this.setState({placesNearbyI:this.state.placesNearbyI+1},() =>{this.findRemoveTrain(this.state.placesNearby[this.state.placesNearbyI])})
                      }
                      

                    })


  }

    decode(t, e) {
    for (
      var n,
        o,
        u = 0,
        l = 0,
        r = 0,
        d = [],
        h = 0,
        i = 0,
        a = null,
        c = Math.pow(10, e || 5);
      u < t.length;

    ) {
      (a = null), (h = 0), (i = 0);
      do
        (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
      while (a >= 32);
      (n = 1 & i ? ~(i >> 1) : i >> 1), (h = i = 0);
      do
        (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
      while (a >= 32);
      (o = 1 & i ? ~(i >> 1) : i >> 1), (l += n), (r += o), d.push([
        l / c,
        r / c,
      ]);
    }
    return (d = d.map(function(t) {
      return { latitude: t[0], longitude: t[1] };
    }));
  }



  componentDidMount(){

        if(this.props.racePlaceStartName!=undefined && this.props.racePlaceEndName!=undefined){ 

          var fetchURLparams={origin:this.props.racePlaceStartName ,type:"directions", key: info.googleMapsKey, minimizeRequest:true,destination:this.props.racePlaceEndName}

          fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"}).then(response => response.json()).then(responseJson => {
              if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);

              console.log(responseJson)
        
              if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length>0) {
                var coords=this.decode(responseJson.routes[0].overview_polyline.points);

                if(this.props.racePlaceEndName.toUpperCase().search("GARE")!='-1' && this.props.racePlaceStartName.toUpperCase().search("GARE")=='-1') this.findPlace({latitude:responseJson.routes[0].legs[0]["end_location"].lat,longitude:responseJson.routes[0].legs[0]["end_location"].lng })
                else this.findPlace({latitude:responseJson.routes[0].legs[0]["start_location"].lat,longitude:responseJson.routes[0].legs[0]["start_location"].lng })
              
              }

            })
    

        } else if(this.props.stationPosition!=undefined){ 

          /*je vais récupérer la gare*/
          this.findPlace(this.props.stationPosition)
        }

    }


convertDate(dateConv){

  var date=dateConv[0]+dateConv[1]+dateConv[2]+dateConv[3]+"-"+dateConv[4]+dateConv[5]+"-"+dateConv[6]+dateConv[7]+"T"+dateConv[9]+dateConv[10]+":"+dateConv[11]+dateConv[12]+":00Z"
  date=new Date(date);
  return date

}

viewDetail(){
  if(this.state.viewDetailTrajet==false){
      if(this.state.detailTrajet==undefined){
          this.setState({waitDetailTrajet:true, viewDetailTrajet:true});
          console.log(this.state.journey)
          fetch("https://api.sncf.com/v1/coverage/sncf/vehicle_journeys/"+this.state.journey+"/?", {method: "GET",headers: {'Authorization': '670396b7-c369-4eae-bb7e-eb3f17426463', 'Content-Type': 'application/x-www-form-urlencoded'}, }).then(response => response.json()).then(responseJson => {
          /*je vais une requête pour afficher le détail du trajet */
          
          this.setState({waitDetailTrajet:false});

          if(responseJson.vehicle_journeys!=undefined && responseJson.vehicle_journeys[0]!=undefined && responseJson.vehicle_journeys[0].stop_times!=undefined){
              var i,j;
              var stop=[]; 
              var stInfo;
              var stopSearch;
              var cause="";
              for(i=0; i<responseJson.vehicle_journeys[0].stop_times.length;i++){
                stInfo={bold:(responseJson.vehicle_journeys[0].stop_times[i].stop_point.label==this.state.stationName)?true:false,id:responseJson.vehicle_journeys[0].stop_times[i].stop_point.id, name:responseJson.vehicle_journeys[0].stop_times[i].stop_point.name, date:responseJson.vehicle_journeys[0].stop_times[i].departure_time[0]+responseJson.vehicle_journeys[0].stop_times[i].departure_time[1]+":"+responseJson.vehicle_journeys[0].stop_times[i].departure_time[2]+responseJson.vehicle_journeys[0].stop_times[i].departure_time[3]}

                if(responseJson.disruptions!=undefined && responseJson.disruptions[0]!=undefined && responseJson.disruptions[0].impacted_objects!=undefined && responseJson.disruptions[0].impacted_objects[0]!=undefined && responseJson.disruptions[0].impacted_objects[0].impacted_stops!=undefined ){
                  j=0;
                  stopSearch=false; 
                  while(j<responseJson.disruptions[0].impacted_objects[0].impacted_stops.length && stopSearch==false){
                      if( responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].stop_point.id==stInfo.id){
                        if(responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].departure_status=="deleted") stInfo.deleted=true;
                        else if(responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].amended_departure_time!=undefined) {
                          stInfo.newDate=responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].amended_departure_time[0]+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].amended_departure_time[1]+":"+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].amended_departure_time[2]+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].amended_departure_time[3]
                          stInfo.date=responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].base_departure_time[0]+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].base_departure_time[1]+":"+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].base_departure_time[2]+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].base_departure_time[3]
                          if(cause=="" && responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].base_departure_time[0]+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].cause!="" && responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].base_departure_time[0]+responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].cause!="") cause=responseJson.disruptions[0].impacted_objects[0].impacted_stops[j].cause; 
                        }
                        stopSearch=true;
                      }
                      else j++;
                  }
                  
                }
                stop.push(stInfo); 
              

              }

              



              this.setState({detailTrajet:stop})
              if(cause!="") this.setState({cause:cause})
          }
          else this.setState({detailTrajet:"noResult"})
          

          })




      } else {
          this.setState({viewDetailTrajet:true})
      }

  }
  else this.setState({viewDetailTrajet:false})


  

  
}

  render() {


    return (
      <StyleContext.Consumer>{style => 
          <View style={(this.props.style==undefined)?{}:this.props.style}>



            <View style={{justifyContent:"space-between", flexDirection:"row", alignItems:"center"}}>

                    <View style={{flexDirection:"row", alignItems:"center",}} >
                        <Image source={(this.state.noService==true || this.state.trainName=="TGV")?require('../assets/sncf/sncf.png'): ((this.state.trainName=="OUIGO")?require('../assets/sncf/ouigo.png'):( (this.state.trainName=="TER")? require('../assets/sncf/ter.png') :( (this.state.trainName=="RER")? require('../assets/sncf/rer.png'): ( (this.state.trainName=="TGV Lyria")? require('../assets/sncf/lyria.png'): ((this.state.trainName=="Thalys")? require('../assets/sncf/thalys.png') :( (this.state.trainName=="TGV INOUI")? (style.mode=="light")?require('../assets/sncf/inoui_light.png'):require('../assets/sncf/inoui_dark.png') : ((style.mode=="light")?require('../assets/favorite/train_black.png'):require('../assets/favorite/train_white.png'))  )  ) )  )  ))} style={{height:25,width:25,resizeMode:"contain", marginTop:-3, marginRight:6}}/>
                        
                        <View style={{alignItems:"flex-start"}}>
                            <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { if(this.state.viewDetailTrajet!=true && this.props.editable==true) this.setState({changeNumber:!this.state.changeNumber}) }}>
                               <View style={{flexDirection:"row"}}>
                                    <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.75,textAlign: "center",}}>{(this.state.trainName!=undefined)?(this.state.trainName.toUpperCase()+" N°") :strings.numeroTrain.toUpperCase()}</Text>
                                    {(this.state.viewDetailTrajet!=true && this.props.editable==true) && <Image source={(style.mode=="dark")?require('../assets/edit_white.png'):require('../assets/edit_black.png')} style={{height:12,width:12,marginLeft:5, resizeMode:"contain"}}/>}
                              </View>
                            </TouchableHighlight>
                            <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.setState({changeNumber:!this.state.changeNumber}) }}>
                              
                                  <View style={{flexDirection:"row", alignItems:"center", marginTop:-3}}>
                                      <Text style={{marginLeft:-2,color: style.textInputColor,fontSize: style.textInputFontSize*1.35,textAlign: "center",}}>{this.state.numTrain}</Text>
                                  </View>


                            </TouchableHighlight>
                        </View>

                    </View>


                    <View>

                    {(this.state.changeNumber!=true && this.state.hourTrain!=undefined && this.state.realHourTrain==undefined && this.state.viewDetailTrajet!=true) && <View style={{ alignItems:"flex-end" }}>

                          <Text style={{fontSize:style.textInputFontSize*0.8,color:style.textInputColor,}}>{strings.arrivalAt+" "}<Text style={{fontSize:style.textInputFontSize*1,color:style.textInputColor,fontWeight: 'bold',}}>{this.state.hourTrain}</Text></Text> 
                          
                          <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { if(this.state.hideIconi!=true) this.viewDetail() }}>
                              <View style={{flexDirection:"row", alignItems:"center" }} >
                                {this.state.hideIconi!=true && <Image source={require('../assets/iconi_green.png')} style={{height:13,width:13,resizeMode:"contain", }}/>}
                              <Text style={{marginLeft:2,fontSize:style.textInputFontSize,color:style.colorValidate,fontWeight: 'bold'}}>{strings.trainAtTime}</Text>
                              </View>
                          </TouchableHighlight>

                    
                    </View>}

                     {(this.state.changeNumber!=true && this.state.hourTrain!=undefined && this.state.realHourTrain!=undefined && this.state.viewDetailTrajet!=true) && <View style={{ alignItems:"flex-end" }}>

                          <Text style={{fontSize:style.textInputFontSize*0.8,color:style.textInputColor,}}>{strings.arrivalAt+" "}<Text style={{color:style.textInputColor,textDecorationLine: 'line-through', textDecorationStyle: 'solid'}}>{this.state.hourTrain}</Text><Text style={{fontSize:style.textInputFontSize*1,color:style.colorNotification,fontWeight: 'bold',}}>{" "+this.state.realHourTrain}</Text></Text> 
                          
                          <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { if(this.state.hideIconi!=true) this.viewDetail() }}>

                            <View style={{flexDirection:"row", alignItems:"center" }} >
                              {this.state.hideIconi!=true && <Image source={require('../assets/iconi_red.png')} style={{height:13,width:13,resizeMode:"contain", }}/>}
                              <Text style={{marginLeft:2, fontSize:style.textInputFontSize,color:style.colorNotification,fontWeight: 'bold'}}>{strings.delayOf+" "+this.state.delay}</Text>
                            </View>
                          </TouchableHighlight>

                    </View>}

                    {this.state.noService==true && <Text style={{fontSize:style.textInputFontSize,color:style.colorNotification,fontWeight: 'bold'}}>{strings.trainDeleted}</Text> }

                    {(this.state.changeNumber==true || this.state.viewDetailTrajet==true) && <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.close} onlyButton={true}  onPress={()=>{ if(this.state.viewDetailTrajet==true) this.setState({viewDetailTrajet:false}) ; else this.setState({changeNumber:false})  }} />}
    
                    </View>

          </View>

          {(this.state.viewDetailTrajet==true) && <MavViewMore hideTopbar={true} style={{marginTop:5 }} defautVisible={true} text={ "" }  >
              {(this.state.waitDetailTrajet==true) && <ActivityIndicator style={{marginTop:35,marginBottom:35}} size="large" color={style.color1} />}

              {(this.state.detailTrajet=="noResult") && <Text style={{marginTop:15, color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.8,textAlign: "center",}}>{strings.noInfo}</Text>}
              
              {(this.state.detailTrajet!=undefined && this.state.detailTrajet!="noResult") && <View style={{marginTop:7, marginLeft:10, marginRight:10}}>



                  <View style={{flexDirection:"row", alignItems:"center",marginBottom:10}} >
                        <Image source={require('../assets/sncf/sncf.png')} style={{height:25,width:20,resizeMode:"contain", marginRight:6}}/>
                        {this.state.cause==undefined && <View>
                          <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.8,textAlign: "left",}}>{strings.infoBySNCF}</Text>
                          <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.6,textAlign: "left",marginTop:-2}}>{strings.indicatifOnly}</Text>
                        </View>}
                        {this.state.cause!=undefined && <View>
                          <Text style={{color: style.colorNotification,fontStyle: 'italic',fontSize: style.textInputFontSize*1,textAlign: "left",fontWeight:"bold"}}>{this.state.cause}</Text>
                          <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.6,textAlign: "left",marginTop:-2}}>{strings.indicatifOnly}</Text>
                        </View>}

                  
                  </View>


                <View style={{justifyContent: 'space-between',flexDirection: 'row',height:30, marginLeft:5 }}>
                      <View style={{flexDirection: 'row',maxWidth:"75%",}}>
                        <View style={{ marginRight:10, }}>
                            <View style={{width:10, height:10,borderRadius: 5, backgroundColor:style.color1, }}/>
                            <View style={{width:2, height:11, backgroundColor:style.color1, marginLeft:4 }}/>
                            <View style={{width:2, height:11, backgroundColor:style.color1, marginLeft:4 }}/>
                        </View>
                        
                            <Text style={{ fontSize:style.textInputFontSize*0.8,color:style.textInputColor,marginTop:-1, textDecorationLine: (this.state.detailTrajet[0].deleted==true)?'line-through':undefined,  fontWeight: (this.state.detailTrajet[0].bold==true)?'bold':undefined}}>{this.state.detailTrajet[0].name}</Text>
                         
                      </View>
                      <View style={{flexDirection:'row', alignItems:"center", marginTop:-10}}>
                              <Text style={{fontSize:style.textInputFontSize*((this.state.detailTrajet[0].newDate!=undefined)?0.7:1),color:style.textInputColor,marginTop:-2, textDecorationLine: (this.state.detailTrajet[0].deleted==true || this.state.detailTrajet[0].newDate!=undefined)?'line-through':undefined,  fontWeight: (this.state.detailTrajet[0].bold==true)?'bold':undefined}}>{this.state.detailTrajet[0].date}</Text>
                              {this.state.detailTrajet[0].newDate!=undefined && <Text style={{marginLeft:5, fontSize:style.textInputFontSize,color:style.colorNotification,marginTop:-2,  fontWeight: (this.state.detailTrajet[0].bold==true)?'bold':undefined}}>{this.state.detailTrajet[0].newDate}</Text>}
                          </View>

                </View>


                {this.state.detailTrajet.map((rowData, stI)=>(     
                    <View>
                    {(stI!=0 && stI!=this.state.detailTrajet.length-1) &&  <View style={{justifyContent: 'space-between',flexDirection: 'row',height:30, marginLeft:5}}>
                          <View style={{flexDirection: 'row',maxWidth:"75%"}}>
                            <View style={{ marginRight:10,}}>
                                <View style={{width:10, height:10, borderRadius: 5, borderColor:style.color1,borderWidth:2 }}/>
                                <View style={{width:2, height:11,  backgroundColor:style.color1, marginLeft:4, }}/>
                                <View style={{width:2, height:11,  backgroundColor:style.color1, marginLeft:4, }}/>
                            </View>
                             
                            <Text style={{ fontSize:style.textInputFontSize*0.8,color:style.textInputColor,marginTop:-1,textDecorationLine: (this.state.detailTrajet[stI].deleted==true)?'line-through':undefined, fontWeight: (this.state.detailTrajet[stI].bold==true)?'bold':undefined}}>{this.state.detailTrajet[stI].name}</Text>
                            
                          </View>
                          <View style={{flexDirection:'row', alignItems:"center", marginTop:-10}}>
                              <Text style={{fontSize:style.textInputFontSize*((this.state.detailTrajet[stI].newDate!=undefined)?0.7:1),color:style.textInputColor,marginTop:-2, textDecorationLine: (this.state.detailTrajet[stI].deleted==true || this.state.detailTrajet[stI].newDate!=undefined)?'line-through':undefined,  fontWeight: (this.state.detailTrajet[stI].bold==true)?'bold':undefined}}>{this.state.detailTrajet[stI].date}</Text>
                              {this.state.detailTrajet[stI].newDate!=undefined && <Text style={{marginLeft:5, fontSize:style.textInputFontSize,color:style.colorNotification,marginTop:-2,  fontWeight: (this.state.detailTrajet[stI].bold==true)?'bold':undefined}}>{this.state.detailTrajet[stI].newDate}</Text>}
                          </View>

                    </View>}
                    </View>
                 ))}


                 <View style={{justifyContent: 'space-between',flexDirection: 'row', marginLeft:5 }}>
                      <View style={{flexDirection: 'row',maxWidth:"75%",}}>
                        <View style={{ marginRight:10, }}>
                            <View style={{width:10, height:10,borderRadius: 5, backgroundColor:style.color1, }}/>
                        </View>
                        
                            <Text style={{ fontSize:style.textInputFontSize*0.8,color:style.textInputColor,marginTop:-2,fontWeight: (this.state.detailTrajet[this.state.detailTrajet.length-1].bold==true)?'bold':undefined}}>{this.state.detailTrajet[this.state.detailTrajet.length-1].name}</Text>
                         
                      </View>

                      <View style={{flexDirection:'row', alignItems:"center", marginTop:0}}>
                              <Text style={{fontSize:style.textInputFontSize*((this.state.detailTrajet[this.state.detailTrajet.length-1].newDate!=undefined)?0.7:1),color:style.textInputColor,marginTop:-2, textDecorationLine: (this.state.detailTrajet[this.state.detailTrajet.length-1].deleted==true || this.state.detailTrajet[this.state.detailTrajet.length-1].newDate!=undefined)?'line-through':undefined,  fontWeight: (this.state.detailTrajet[this.state.detailTrajet.length-1].bold==true)?'bold':undefined}}>{this.state.detailTrajet[this.state.detailTrajet.length-1].date}</Text>
                              {this.state.detailTrajet[this.state.detailTrajet.length-1].newDate!=undefined && <Text style={{marginLeft:5, fontSize:style.textInputFontSize,color:style.colorNotification,marginTop:-2,  fontWeight: (this.state.detailTrajet[this.state.detailTrajet.length-1].bold==true)?'bold':undefined}}>{this.state.detailTrajet[this.state.detailTrajet.length-1].newDate}</Text>}
                      </View>


                </View>





               </View>}

          </MavViewMore>}
          


          {(this.state.changeNumber==true && this.props.editable==true) && <MavViewMore hideTopbar={true} style={{marginTop:5 }} defautVisible={true} text={ "" }  >

                  <MavTextInput style={{marginTop:15}} textInputFlex={1.3} disableLine={true} text={this.state.numTrain} backgroundColor={style.backgroundColorContrast } textExplication={strings.numeroTrain} placeholder={"ex : 6504"} onChangeText={(text)=>{this.setState({numTrain: text })}}/>
             
                  <View style={{width:"100%", alignItems:"center", justifyContent:"center", marginTop:10}}> 
                      <MavButton onlyButton={true} small={true} text={strings.confirm} onPress={()=>{this.setState({changeNumber:false, placesNearbyI:0},() =>{if(this.state.placesNearby!=undefined) this.findStationInfo(this.state.placesNearby[0])}); if(this.props.onChangeNumber!=null) this.props.onChangeNumber(this.state.numTrain); }} />
                  </View>

          </MavViewMore>}

            
        </View>

      }</StyleContext.Consumer>


    	)}

    }

